import React from 'react';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Divider, Typography, Box } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import BarChartIcon from '@mui/icons-material/BarChart';
import QuizIcon from '@mui/icons-material/Quiz';
import LogoutIcon from '@mui/icons-material/Logout';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import cookie from 'react-cookies'
import { useHistory } from 'react-router-dom';

const Sidebar = () => {
  const history = useHistory()

  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }

  const menuItems = [
    { text: 'Étudiants', path: '/admin-etudiants', icon: <ContactMailIcon /> },
    { text: 'Groupes', path: '/admin-groupes', icon: <GroupsIcon /> },
    { text: 'Questions', path: '/admin-questions', icon: <QuizIcon /> },
    { text: 'Classements', path: '/admin-classements', icon: <EmojiEventsIcon /> },
    // Comme Play & Learn
    { text: 'Stats Application', path: '/admin-statistiques-app', icon: <BarChartIcon /> },
    { text: 'Stats Jeux', path: '/admin-statistiques-jeux', icon: <BarChartIcon /> },
  ];

  return (
    <Drawer
    variant="permanent"
    anchor="left"
    sx={{
      width: 240,
      flexShrink: 0,
      '& .MuiDrawer-paper': {
        width: 240,
        boxSizing: 'border-box',
        backgroundColor: '#1e272e',
        color: '#ffffff',
        paddingLeft: '16px',
      },
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px 0',
      }}
      >
        <Typography noWrap>
          Espace administrateur
        </Typography>
      </Box>
      <Divider style={{ backgroundColor: '#57606f' }} />
      <List>
        {menuItems.map((item, index) => (
          <ListItem button key={index} onClick={() => window.location.pathname = item.path}>
            <ListItemIcon sx={{ color: '#ffffff' }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      <Divider style={{ backgroundColor: '#57606f' }} />
      <List>
        <ListItem button onClick={() => handleDisconnect()}>
          <ListItemIcon sx={{ color: '#ffffff' }}>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="Se déconnecter" />
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar;
